import {AfterViewInit, Component} from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'pm-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements AfterViewInit {

  constructor() {
  }

  ngAfterViewInit(): void {
    $(document).ready(() => {
      if ($(window).width() > 991) {
        // footer fixed js
        $(document).ready(() => {
          const footerPadd = $('footer').height() + 'px';
          $('main').css('margin-bottom', footerPadd);
        });
      }
    });
    this.initThemeSwitch();
    this.initScroll();
  }

  initScroll(): void {
    $(document).ready(() => {
      $(window).scroll(() => {
        if ($(this).scrollTop() > 100) {
          $('#scroll').fadeIn();
        } else {
          $('#scroll').fadeOut();
        }
      });
      $('#scroll').click(() => {
        $('html').animate({scrollTop: 0}, 500);
        return false;
      });
    });
  }

  initThemeSwitch(): void {
// Theme switch
    // @ts-ignore
    const themeSwitch: HTMLInputElement = document.getElementById('themeSwitch');
    if (themeSwitch) {
      initTheme(); // if user has already selected a specific theme -> apply it
      themeSwitch.addEventListener('change', (event) => {
        resetTheme(); // update color theme
      });

      function initTheme(): void {
        const darkThemeSelected = (localStorage.getItem('themeSwitch') !== null && localStorage.getItem('themeSwitch') === 'dark');
        // update checkbox
        $('body').removeClass('dark-mode');
        themeSwitch.checked = darkThemeSelected;
        // update body data-theme attribute

        darkThemeSelected ? document.body.setAttribute('id', 'dark') : document.body.removeAttribute('id');

      }

      if ($('.switch input').prop('checked') === true) {
        $('body').addClass('dark-mode');
      } else {
        $('body').removeClass('dark-mode');
      }

      function resetTheme(): void {
        if (themeSwitch.checked) { // dark theme has been selected
          document.body.setAttribute('id', 'dark');
          $('body').addClass('dark-mode');
          localStorage.setItem('themeSwitch', 'dark');
        } else {
          document.body.removeAttribute('id');
          localStorage.removeItem('themeSwitch');
          $('body').removeClass('dark-mode');
        }
      }
    }
  }

}
